
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "undefined";
              window.beaePageSetting.pageTitle = "findus"; 
              window.beaePageSetting.pageType = "page";

          let js_DCSBQ83L = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-sawtc5e7section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-sawtc5e7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-sawtc5e7');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-sawtc5e7: ', ex)
      };
    

      try {
        let argid = 'beae-n8u628sjsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-n8u628sj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-n8u628sj');
        args.el = args.els[0];
        ((g) => { window.BeaeSlider&&!g.noRunJs&&window.BeaeSlider(g) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-n8u628sj: ', ex)
      };
    

      try {
        let argid = 'beae-qbe2tpayblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qbe2tpay',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qbe2tpay');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qbe2tpay: ', ex)
      };
    

      try {
        let argid = 'beae-k7kfnbgdblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-k7kfnbgd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-k7kfnbgd');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-k7kfnbgd: ', ex)
      };
    

      try {
        let argid = 'beae-qbe2tpayblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qbe2tpay',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qbe2tpay');
        args.el = args.els[1];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qbe2tpay: ', ex)
      };
    

      try {
        let argid = 'beae-k7kfnbgdblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-k7kfnbgd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-k7kfnbgd');
        args.el = args.els[1];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-k7kfnbgd: ', ex)
      };
    

      try {
        let argid = 'beae-qbe2tpayblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qbe2tpay',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qbe2tpay');
        args.el = args.els[2];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qbe2tpay: ', ex)
      };
    

      try {
        let argid = 'beae-k7kfnbgdblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-k7kfnbgd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-k7kfnbgd');
        args.el = args.els[2];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-k7kfnbgd: ', ex)
      };
    

      try {
        let argid = 'beae-qbe2tpayblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qbe2tpay',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qbe2tpay');
        args.el = args.els[3];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qbe2tpay: ', ex)
      };
    

      try {
        let argid = 'beae-k7kfnbgdblock-textloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-k7kfnbgd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-k7kfnbgd');
        args.el = args.els[3];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-k7kfnbgd: ', ex)
      };
    

      try {
        let argid = 'beae-mzepq0zssection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mzepq0zs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mzepq0zs');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mzepq0zs: ', ex)
      };
    

      try {
        let argid = 'beae-mzepq0zssection-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mzepq0zs',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mzepq0zs');
        args.el = args.els[0];
        ((data
) => { function formFocusHandle() {
  const formFields = data.el.querySelectorAll('.beae-form-field');
  const inputWrapper = data.el.querySelector('.beae-form-container');

  if (formFields.length === 0 || inputWrapper == null) return;

  formFields.forEach((formField) => {
    const input = formField.querySelector('input, textarea');

    if (!input) return;

    input.addEventListener('focus', () => {
      inputWrapper.classList.add('beae-user-focus'); 
      formField.classList.add('active'); 
    });

    input.addEventListener('blur', () => {
      if (input.value == '') { 
        formField.classList.remove('active'); 
      }
    });
  });
}

formFocusHandle(); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mzepq0zs: ', ex)
      };
    

      try {
        let argid = 'beae-d5xynfwbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-d5xynfwb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-d5xynfwb');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-d5xynfwb: ', ex)
      };
    

      try {
        let argid = 'beae-0jgv0j5nblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0jgv0j5n',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0jgv0j5n');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0jgv0j5n: ', ex)
      };
    

      try {
        let argid = 'beae-u5hkh9yzsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-u5hkh9yz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-u5hkh9yz');
        args.el = args.els[0];
        ((g) => { window.BeaeSlider&&!g.noRunJs&&window.BeaeSlider(g) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-u5hkh9yz: ', ex)
      };
    

      try {
        let argid = 'beae-pi3weykjblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pi3weykj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pi3weykj');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pi3weykj: ', ex)
      };
    

      try {
        let argid = 'beae-pi3weykjblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pi3weykj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pi3weykj');
        args.el = args.els[1];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pi3weykj: ', ex)
      };
    

      try {
        let argid = 'beae-pi3weykjblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pi3weykj',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pi3weykj');
        args.el = args.els[2];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pi3weykj: ', ex)
      };
    

      try {
        let argid = 'beae-8gn0n2m7block-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8gn0n2m7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8gn0n2m7');
        args.el = args.els[0];
        ((h) => { const g=window.location.href.indexOf("contact_posted=true")!==-1,u=h.el.querySelector("form");h.el.querySelector(".beae-btn-pr");const f=h.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),b=h.el.querySelector(".btn-lightbox-form > button");!g&&h.mode.value!=="builder"&&(h.el.querySelector(".beae-form-success-message").style="display: none"),g&&h.afterSubmitting=="redirect"&&h.redirect&&(h.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=h.redirect);const k=[];u&&u.addEventListener("submit",m=>{m.preventDefault();for(let y=0;y<f.length;y++)k.push({fieldKey:f[y].name,fieldType:f[y].type,fieldValue:f[y].value})}),b&&(b.onclick=()=>{const m=document.createElement("div");m.innerHTML=u.outerHTML||"",window.BeaePopupLibrary.createPopup(m,{layout:"center",layoutMobile:"bottom",width:"500px",id:h.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8gn0n2m7: ', ex)
      };
    }; if (window.BEAEBASE) {js_DCSBQ83L()} else {window.BEAEPAGEJS.push(js_DCSBQ83L)} })(); 